import { CategoryData } from '../../../../types/types';

export const verbes: CategoryData = {
    // Essentiels — partie 1
    'Ka taa (aller)': {
        translation: 'aller',
        translationEn: 'to go',
        illustration: '👉'
    },
    'Ka na (venir)': {
        translation: 'venir',
        translationEn: 'to come',
        illustration: '👈',
        audio: 'Ba-ka_na'
    },
    'Ka dun (manger)': {
        translation: 'manger',
        translationEn: 'to eat',
        illustration: '🍽️'
    },
    'Ka min (boire)': {
        translation: 'boire',
        translationEn: 'to drink',
        illustration: '🥤',
        audio: 'Ba-ka_min'
    },
    'Ka sunɔgɔ (dormir)': {
        translation: 'dormir',
        translationEn: 'to sleep',
        illustration: '😴'
    },
    'Ka kuma (parler)': {
        translation: 'parler',
        translationEn: 'to speak',
        illustration: '🗣️',
        audio: 'Ba-ka_kuma'
    },
    'Ka fɔ (dire)': {
        translation: 'dire',
        translationEn: 'to say',
        illustration: '💬'
    },
    'Ka yira (voir)': {
        translation: 'voir',
        translationEn: 'to see',
        illustration: '👀',
        audio: 'Ba-ka_yira'
    },
    'Ka kanu (aimer)': {
        translation: 'aimer',
        translationEn: 'to love',
        illustration: '❤️'
    },
    'Ka san (acheter)': {
        translation: 'acheter',
        translationEn: 'to buy',
        illustration: '🛍️',
        audio: 'Ba-ka_san'
    },
    'Ka baara (travailler)': {
        translation: 'travailler',
        translationEn: 'to work',
        illustration: '🔨',
        audio: 'Ba-ka_baara'
    },
    'Ka foli (saluer)': {
        translation: 'saluer',
        translationEn: 'to greet',
        illustration: '👋'
    },
    'Ka ɲininka (demander)': {
        translation: 'demander',
        translationEn: 'to ask',
        illustration: '❓'
    },
    'Ka jaabi (répondre)': {
        translation: 'répondre',
        translationEn: 'to answer',
        illustration: '↩️'
    },
    'Ka lamɛn (écouter)': {
        translation: 'écouter',
        translationEn: 'to listen',
        illustration: '👂'
    },
    'Ka dɔn (connaître)': {
        translation: 'connaître',
        translationEn: 'to know',
        illustration: '🧠'
    },
    'Ka wuli (se lever)': {
        translation: 'se lever',
        translationEn: 'to get up',
        illustration: '🧍',
        audio: 'Ba-ka_wuli'
    },
    'Ka sigi (s\'asseoir)': {
        translation: 's\'asseoir',
        translationEn: 'to sit down',
        illustration: '💺',
        audio: 'Ba-ka_sigi'
    },
    'Ka taama (marcher)': {
        translation: 'marcher',
        translationEn: 'to walk',
        illustration: '🚶'
    },
    'Ka kɔngɔ (avoir faim)': {
        translation: 'avoir faim',
        translationEn: 'to be hungry',
        illustration: '🍽️'
    },

    // Courants — partie 2
    'Ka minɔgɔ (avoir soif)': {
        translation: 'avoir soif',
        translationEn: 'to be thirsty',
        illustration: '🥤'
    },
    'Ka bɔn (être fatigué)': {
        translation: 'être fatigué',
        translationEn: 'to be tired',
        illustration: '😫'
    },
    'Ka weele (appeler)': {
        translation: 'appeler',
        translationEn: 'to call',
        illustration: '📞',
        audio: 'Ba-ka_weele'
    },
    'Ka kalan (étudier/lire)': {
        translation: 'étudier/lire',
        translationEn: 'to study/read',
        illustration: '📚',
        audio: 'Ba-ka_kalan'
    },
    'Ka sɛbɛn (écrire)': {
        translation: 'écrire',
        translationEn: 'to write',
        illustration: '✍️'
    },
    'Ka kalali (jouer)': {
        translation: 'jouer',
        translationEn: 'to play',
        illustration: '🎮'
    },
    'Ka tobi (cuisiner)': {
        translation: 'cuisiner',
        translationEn: 'to cook',
        illustration: '🍳'
    },
    'Ka ko (se laver)': {
        translation: 'se laver',
        translationEn: 'to wash oneself',
        illustration: '🚿',
        audio: 'Ba-ka_ko'
    },
    'Ka la (se coucher)': {
        translation: 'se coucher',
        translationEn: 'to lie down',
        illustration: '🛏️',
        audio: 'Ba-ka_la'
    },
    'Ka Se (arriver)': {
        translation: 'arriver',
        translationEn: 'to arrive',
        illustration: '📍',
        audio: 'Ba-ka_se'
    },
    'Ka segin (retourner)': {
        translation: 'retourner',
        translationEn: 'to return',
        illustration: '↩️'
    },
    'Ka boli (courir)': {
        translation: 'courir',
        translationEn: 'to run',
        illustration: '🏃'
    },
    'Ka dɛmɛ (aider)': {
        translation: 'aider',
        translationEn: 'to help',
        illustration: '🤝'
    },
    'Ka sara (payer)': {
        translation: 'payer',
        translationEn: 'to pay',
        illustration: '💰'
    },
    'Ka soro (chercher)': {
        translation: 'chercher',
        translationEn: 'to look for',
        illustration: '🔍',
        audio: 'Ba-ka_soro'
    },
    'Ka laban (finir)': {
        translation: 'finir',
        translationEn: 'to finish',
        illustration: '🏁'
    },
    'Ka daminɛ (commencer)': {
        translation: 'commencer',
        translationEn: 'to start',
        illustration: '🎬',
        audio: 'Ba-ka_damine'
    },
    'Ka jira (montrer)': {
        translation: 'montrer',
        translationEn: 'to show',
        illustration: '👉'
    },
    'Ka yɛlɛ (rire)': {
        translation: 'rire',
        translationEn: 'to laugh',
        illustration: '😂',
        audio: 'Ba-ka_yele'
    },
    'Ka nisɔndiya (être content)': {
        translation: 'être content',
        translationEn: 'to be happy',
        illustration: '😃'
    },

    // Plus rares — plus loin sur le sentier
    'Ka kɛnɛ (être en bonne santé)': {
        translation: 'être en bonne santé',
        translationEn: 'to be healthy',
        illustration: '😊'
    },
    'Ka dimi (avoir mal)': {
        translation: 'avoir mal',
        translationEn: 'to be in pain',
        illustration: '🤕'
    },
    'Ka kasi (pleurer)': {
        translation: 'pleurer',
        translationEn: 'to cry',
        illustration: '😢'
    },
    'Ka siran (avoir peur)': {
        translation: 'avoir peur',
        translationEn: 'to be afraid',
        illustration: '😨'
    },
    'Ka seli (prier)': {
        translation: 'prier',
        translationEn: 'to pray',
        illustration: '🙏'
    },
    'Ka don (danser)': {
        translation: 'danser',
        translationEn: 'to dance',
        illustration: '💃'
    },
    'Ka sɔn (accepter)': {
        translation: 'accepter',
        translationEn: 'to accept',
        illustration: '👍'
    },
    'Ka ban (refuser)': {
        translation: 'refuser',
        translationEn: 'to refuse',
        illustration: '👎',
        audio: 'Ba-ka_ban'
    },
    'Ka fɛrɛ (partager)': {
        translation: 'partager',
        translationEn: 'to share',
        illustration: '🤲'
    },
    'Ka sanni (acheter/vendre)': {
        translation: 'acheter/vendre',
        translationEn: 'to buy/sell',
        illustration: '🛒'
    },
    'Ka wele (appeler)': {
        translation: 'appeler',
        translationEn: 'to call',
        illustration: '📞'
    },
    'Ka bilasira (accompagner)': {
        translation: 'accompagner',
        translationEn: 'to accompany',
        illustration: '👫',
        audio: 'Ba-Ka_bilasira'
    },
    'Ka mana (allumer)': {
        translation: 'allumer',
        translationEn: 'to turn on',
        illustration: '💡',
        audio: 'Ba-ka_mana'
    },
    'Ka jigin (descendre)': {
        translation: 'descendre',
        translationEn: 'to go down',
        illustration: '⬇️'
    },
    'Ka yɛlɛn (monter)': {
        translation: 'monter',
        translationEn: 'to go up',
        illustration: '⬆️'
    },
    'Ka pan (sauter)': {
        translation: 'sauter',
        translationEn: 'to jump',
        illustration: '🦘'
    },
    'Ka joosi (réveiller)': {
        translation: 'réveiller',
        translationEn: 'to wake up',
        illustration: '⏰',
        audio: 'Ba-ka_joosi'
    },
    'Ka gosi (nettoyer)': {
        translation: 'nettoyer',
        translationEn: 'to clean',
        illustration: '🧹',
        audio: 'Ba-ka_gosi'
    },
    'Ka furake (soigner)': {
        translation: 'soigner',
        translationEn: 'to treat/heal',
        illustration: '💊',
        audio: 'Ba-ka_furake'
    },
    'Ka dogo (rester debout)': {
        translation: 'rester debout',
        translationEn: 'to stand',
        illustration: '🕴️',
        audio: 'Ba-ka_dogo'
    },
    'Ka teme (passer)': {
        translation: 'passer',
        translationEn: 'to pass',
        illustration: '',
        audio: 'Ba-ka_teme'
    },
    'Ka tunu (piler)': {
        translation: 'piler',
        translationEn: 'to pound',
        illustration: '🔨',
        audio: 'Ba-ka_tunu'
    },
    'Ka jalaki (gronder)': {
        translation: 'gronder',
        translationEn: 'to scold',
        illustration: '😠'
    },
    'Ka fili (se tromper)': {
        translation: 'se tromper',
        translationEn: 'to be mistaken',
        illustration: '❌',
        audio: 'Ba-ka_fili'
    },
    'Ka yɛrɛ (rire)': {
        translation: 'rire',
        translationEn: 'to laugh',
        illustration: '😂'
    },
    'Ka nige (fuir)': {
        translation: 'fuir',
        translationEn: 'to flee',
        illustration: '🏃‍♂️',
        audio: 'Ba-ka_nige'
    },
    'Ka bonya (respecter)': {
        translation: 'respecter',
        translationEn: 'to respect',
        illustration: '🤝',
        audio: 'Ba-ka_bonya'
    },
    'Ka bato (vénérer)': {
        translation: 'vénérer',
        translationEn: 'to worship',
        illustration: '🙏',
        audio: 'Ba-ka_bato'
    },
    'Ka lakana (sécuriser)': {
        translation: 'sécuriser',
        translationEn: 'to secure',
        illustration: '🔒',
        audio: 'Ba-ka_lakana'
    },
    'Ka bagabaga (menacer)': {
        translation: 'menacer',
        translationEn: 'to threaten',
        illustration: '',
        audio: 'Ba-ka_bagabaga'
    },
    'Ka darabo (provoquer)': {
        translation: 'provoquer',
        translationEn: 'to provoke',
        illustration: '',
        audio: 'Ba-ka_darabo'
    },
    'Ka dogoya (dénigrer)': {
        translation: 'dénigrer',
        translationEn: 'to belittle',
        illustration: '',
        audio: 'Ba-ka_dogoya'
    },
    'Ka nige (berner)': {
        translation: 'berner',
        translationEn: 'to deceive',
        illustration: '',
        audio: 'Ba-ka_nige'
    },
    'Ka toli (pourrir)': {
        translation: 'pourrir',
        translationEn: 'to rot',
        illustration: '',
        audio: 'Ba-ka_toli'
    },
    'Ka legelege (chatouiller)': {
        translation: 'chatouiller',
        translationEn: 'to tickle',
        illustration: '',
        audio: 'Ba-ka_legelege'
    },
    'Ka janfa (trahir)': {
        translation: 'trahir',
        translationEn: 'to betray',
        illustration: '',
        audio: 'Ba-ka_janfa'
    }
};

export default verbes;
export {};
